export default {
    listCustomer: '/customer/listcustomerservice',//查询当前登录人归属的客户列表
    productInfo: '/ads/programme/productinfo',// 查询产品
    addProgramme: '/ads/programme/addprogramme',// 添加
    programmeList: '/ads/programme/list',// 获取生成记录

    /** 第二页 */
    secondPageKeyword:'/ai/programme/keyword', // ai生成产品核心关键词API -- 第二页
    secondPageDesc:'/ai/programme/desc', // ai生成产品描述 -- 第二页
    descSummarize:'/ai/programme/descsummarize', // 产品描述ai总结 -- 第二页
    /** 第三页 */
    plannerKeyword:'/ai/programme/plannerkeyword', // 规划师关键词获取 -- 第三页
    addSingleProduct:'/ads/programme/addsingleproduct', // 单个产品修改 -- 第三页
    // 关键词
    aiKeyword:'/ai/programme/aikeyword', // 生成关键词 -- 第三页
    addKeyword:'/ads/programme/addkeyword', // 保存关键词 -- 第三页
    getSavedKeyword: '/ads/programme/getkeyword/{id}',// 获取已保存的关键词 -- 第三页
    emptyKeyword: '/ai/programme/emptykeyword',// 清空关键词 -- 第三页
    keywordAiUpdate: '/ai/programme/keywordaiupdate',// 关键词ai修改 -- 第三页
    getKeywordImage: '/ai/programme/getkeywordimage/{id}',// 获取单个关键词图片 -- 第三页
    aiAddProductKeyword: '/automation/aiaddproductkeyword',// 关键词填充到方案 -- 第三页
    getKeywordTemp:'/ads/programme/getkeywordtemp/{id}',// 获取关键词生成记录 -- 第三页


    // 标题
    adsTitle: '/ai/programme/adstitle',// 广告标题生成 -- 第三页
    emptyTitle: '/ai/programme/emptytitle',// 广告标题清空 -- 第三页
    titleAiUpdate: '/ai/programme/titleaiupdate',// 广告标题AI修改 -- 第三页
    getAdsTitle: '/ads/programme/getadstitle/{id}',// 获取已保存的标题 -- 第三页
    addAdsTitle: '/ads/programme/addadstitle',// 保存标题 -- 第三页
    aiAddProductTitle: '/automation/aiaddproducttitle',// 填充到发难标题、说明 -- 第三页
    getAdsTitleTemp: '/ads/programme/getadstitletemp/{id}',// 填充到发难标题、说明 -- 第三页
    // 描述
    adsIllustrate: '/ai/programme/adsillustrate',// 生成广告说明 -- 第三页
    emptyIllustrate: '/ai/programme/emptyillustrate',// 清空广告说明 -- 第三页
    illustrateAiUpdate: '/ai/programme/illustrateaiupdate',// AI修改广告说明 -- 第三页
    getAdsIllustrate: '/ads/programme/getadsillustrate/{id}',// 获取已保存的广告说明 -- 第三页
    addAdsIllustrate: '/ads/programme/addadsillustrate',// 添加广告说明 -- 第三页
    getAdsIllustrateTemp: '/ads/programme/getadsillustratetemp/{id}',// 添加广告说明 -- 第三页




}